<template>
  <div class="deliveryReportDetail">
    <!-- <h3 class="mb-2">납품일보 상세</h3> -->
    <CodeSearch
      ref="code"
      :data="codeList"
      @selectCode="
        v => {
          this.codeGrade = v;
        }
      "
    />
    <SetPopup ref="confirm" />
    <SetDialog ref="postModalAddressPT">
      <AddressPTSearch :searchRequest="this.searchRequest" @closeModalAddressPT="this.closeAddressPT" @onApprove="this.approveAddressPT" :key="approveAddressPTKey" ref="approveAddressPT"></AddressPTSearch>
    </SetDialog>

    <SetDialog ref="emailListModal">
      <div class="email-list-popup">
        <div class="popup-content">
          <RealGrid domName="emailGrid" ref="emailGrid" :settings="emailGridSettings" />
        </div>
        <div class="popup-footer">
          <v-btn depressed class="btn-sample-request" @click="applyEmails">적용</v-btn>
          <v-btn depressed class="btn-cancle ml-2" @click="closeEmailModal">닫기</v-btn>
        </div>
      </div>
    </SetDialog>

    <RealGrid :oneLineGrid="true" :domName="grid" ref="grid" :settings="this.stat !== 2 ? settingsEditable : settings" :none-page="true" @keypressEvent="onKeyPress" @changeData="compareRowAndGrid" />

    <v-form ref="form" lazy-validation>
      <div class="filter-box filter-box--row mt-6">
        <ul class="filter-list">
          <li>
            <h4>Code Grade</h4>
            <div class="dp--row">
              <v-text-field type="text" :value="displayCodeGrade" outlined dense disabled filled />
              <v-btn depressed class="ml-1 mr-1 btn-add" :disabled="this.stat === 2 || this.data.stat === 2" @click="read">검색</v-btn>
              <v-btn depressed class="btn-save" @click="newCode" :disabled="this.codeGradeExist || buttonDisabled || this.stat === 2">신규생성</v-btn>
              <v-select class="ml-2 origin-limit-select" :items="originLimitOptions" item-text="label" item-value="value" v-model="originLimitCode" outlined dense hide-details :filled="originLimitLocked" :disabled="originLimitLocked" />
              <v-alert v-if="message.length > 0" dense outlined type="error" class="error-alerts"><span v-for="(msg, index) in message" :key="index" v-text="msg" /></v-alert>
            </div>
          </li>
        </ul>
      </div>

      <div class="filter-box--row mt-6 mb-0">
        <div class="filter-box" style="">
          <ul class="filter-list_address">
            <li>
              <h4 class="">분류</h4>
              <v-text-field placeholder="" type="text" outlined dense :disabled="this.stat === 2 || this.data.stat === 2" :filled="this.stat === 2 || this.data.stat === 2" v-model="param.salestype" :style="{ width: '100%' }" />
            </li>
          </ul>
          <ul class="filter-list02" style="margin-top: 30px">
            <li>
              <h4 class="">요청자 연락처<span style="color: blue; font-weight: bold">(- 포함)</span></h4>
              <v-text-field outlined dense v-model="param.phone1" placeholder="- 를 포함 입력" :filled="this.stat === 2 || this.data.stat === 2" :disabled="this.stat === 2 || this.data.stat === 2" :rules="[this.validSet.phoneRules(true, param.phone1)]" minlength="11" maxlength="13" />
            </li>
            <li>
              <h4>요청 업체명</h4>
              <v-text-field outlined disabled filled dense placeholder="" v-model="param.request_company"></v-text-field>
            </li>
            <li>
              <h4>요청자</h4>
              <v-text-field outlined dense placeholder="" v-model="param.request_name" disabled filled></v-text-field>
            </li>
          </ul>
          <ul class="filter-list02" style="margin-top: 30px">
            <li>
              <h4>수령자 연락처<span style="color: blue; font-weight: bold">(- 포함)</span></h4>
              <v-text-field outlined dense :filled="this.stat === 2 || this.data.stat === 2" :disabled="this.stat === 2 || this.data.stat === 2" placeholder="- 를 포함 입력" v-model="param.phone2" :rules="[this.validSet.phoneRules(false, param.phone2)]" minlength="11" maxlength="13"></v-text-field>
            </li>
            <li>
              <h4>수령업체명</h4>
              <v-text-field outlined dense :filled="this.stat === 2 || this.data.stat === 2" :disabled="this.stat === 2 || this.data.stat === 2" placeholder="" v-model="param.pickpart"></v-text-field>
            </li>
            <li>
              <h4>수령자</h4>
              <v-text-field outlined dense :filled="this.stat === 2 || this.data.stat === 2" :disabled="this.stat === 2 || this.data.stat === 2" placeholder="" v-model="param.pick_name" :rules="[this.validSet.empty(param.pick_name, '수령자를 입력해주세요')]"></v-text-field>
            </li>
          </ul>
          <ul class="filter-list_address" style="margin-top: 30px">
            <li>
              <h4>요청 자재코드</h4>
              <v-text-field outlined dense v-model="param.request_code" :filled="this.stat === 2 || this.data.stat === 2" :disabled="this.stat === 2 || this.data.stat === 2"></v-text-field>
            </li>
          </ul>
        </div>

        <div class="filter-box">
          <ul class="filter-list04">
            <li>
              <h4>요청일</h4>
              <v-text-field outlined dense placeholder="" v-mask="'####-##-##'" v-model="param.request_date" disabled filled></v-text-field>
            </li>
            <li class="in_check_box">
              <h4 class="check_cancel">샘플취소</h4>
              <v-checkbox class="checkbox_cancel" v-model="param.cancel"> </v-checkbox>
              <h4 class="check_cancel">COA 필요</h4>
              <v-checkbox class="checkbox_cancel" v-model="param.coawant" :filled="this.stat === 2 || this.data.stat === 2" :disabled="this.stat === 2 || this.data.stat === 2"> </v-checkbox>
              <h4 class="check_cancel">서류만 요청</h4>
              <v-checkbox class="checkbox_cancel" v-model="param.doconly" :filled="this.stat === 2 || this.data.stat === 2" :disabled="this.stat === 2 || this.data.stat === 2"> </v-checkbox>
            </li>
            <li>
              <h4 class="flex v-application justify-space-between"><span>제조 예정일</span> <v-btn v-if="param.produce_due_date !== undefined && param.produce_date == undefined" depressed class="btn-confim dongwha-btn-sm" @click="calendarRemove('produce_due_date')">제조 예정일 삭제</v-btn></h4>
              <v-menu v-model="picker_1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field class="default_cursor" v-model="param.produce_due_date" placeholder="" append-icon="mdi-calendar" outlined dense readonly :filled="filled" :disabled="filled" v-bind="attrs" v-on="on"> </v-text-field>
                </template>
                <v-date-picker no-title v-model="param.produce_due_date" @input="menu = false"> </v-date-picker>
              </v-menu>
            </li>
            <li>
              <h4 class="flex v-application justify-space-between"><span>제조 완료일</span> <v-btn v-if="param.produce_date !== undefined" depressed class="btn-confim dongwha-btn-sm" @click="calendarRemove('produce_date')">제조 완료일 삭제</v-btn></h4>
              <v-menu v-model="picker_2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field class="default_cursor" v-model="param.produce_date" placeholder="" append-icon="mdi-calendar" outlined dense readonly v-bind="attrs" v-on="on" :disabled="produceDateChk || filled || !codeGrade" :filled="filled"></v-text-field>
                </template>
                <v-date-picker no-title v-model="param.produce_date" @input="menu = false"> </v-date-picker>
              </v-menu>
            </li>
            <li>
              <h4 class="flex v-application justify-space-between"><span>출하 예정일</span> <v-btn v-if="param.out_due_date !== undefined && param.out_date == undefined" depressed class="btn-confim dongwha-btn-sm" @click="calendarRemove('out_due_date')">출하 예정일 삭제</v-btn></h4>
              <v-menu v-model="picker_3" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field class="default_cursor" v-model="param.out_due_date" placeholder="" append-icon="mdi-calendar" outlined dense readonly v-bind="attrs" v-on="on" :filled="filled" :disabled="filled"></v-text-field>
                </template>
                <v-date-picker no-title v-model="param.out_due_date" @input="menu = false"></v-date-picker>
              </v-menu>
            </li>
            <li>
              <h4 class="flex v-application justify-space-between"><span>출하 완료일</span> <v-btn v-if="param.out_date !== undefined" depressed class="btn-confim dongwha-btn-sm" @click="calendarRemove('out_date')">출하 완료일 삭제</v-btn></h4>
              <v-menu v-model="picker_4" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field class="default_cursor" v-model="param.out_date" placeholder="" append-icon="mdi-calendar" outlined dense readonly v-bind="attrs" v-on="on" :disabled="filled || !codeGrade" :filled="filled"></v-text-field>
                </template>
                <v-date-picker no-title v-model="param.out_date" @input="menu = false"></v-date-picker>
              </v-menu>
            </li>
            <li>
              <h4 class="flex v-application justify-space-between"><span>납기 예정일</span><v-btn v-if="param.delivery_due_date !== undefined && param.delivery_date == undefined" depressed class="btn-confim dongwha-btn-sm" @click="calendarRemove('delivery_due_date')">납기에정일 삭제</v-btn></h4>
              <v-menu v-model="picker_5" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field class="default_cursor" v-model="param.delivery_due_date" placeholder="" append-icon="mdi-calendar" outlined dense readonly v-bind="attrs" v-on="on" :filled="filled" :disabled="filled"></v-text-field>
                </template>
                <v-date-picker no-title @input="menu = false" v-model="param.delivery_due_date"></v-date-picker>
              </v-menu>
            </li>
            <li>
              <h4 class="flex v-application justify-space-between"><span>납기일</span></h4>
              <v-menu v-model="picker_6" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <!-- <v-text-field v-model="param.delivery_date" placeholder="" append-icon="mdi-calendar" outlined dense readonly v-bind="attrs" v-on="on" :disabled="filled || !codeGrade" :filled="filled"></v-text-field> -->
                  <v-text-field class="default_cursor" v-model="param.delivery_date" placeholder="" append-icon="mdi-calendar" outlined dense readonly v-bind="attrs" v-on="on" :disabled="true" filled></v-text-field>
                </template>
                <v-date-picker no-title @input="menu = false" v-model="param.delivery_date"></v-date-picker>
              </v-menu>
            </li>
          </ul>
        </div>
      </div>

      <div class="filter-box--row">
        <div class="filter-box" style="padding-bottom: 28px">
          <ul class="filter-list04">
            <li>
              <h4>Qty(kg)</h4>
              <v-text-field outlined dense :filled="this.stat === 2 || this.data.stat === 2" :disabled="this.stat === 2 || this.data.stat === 2" placeholder="" v-model="param.qty"></v-text-field>
            </li>
            <li>
              <h4>유/무상</h4>
              <v-select :items="code.P" v-model="param.price_type" placeholder="선택" outlined :filled="this.stat === 2 || this.data.stat === 2" :disabled="this.stat === 2 || this.data.stat === 2" id="work" style="width: 100%"></v-select>
            </li>
            <li>
              <h4>포장 용기</h4>
              <v-select :items="this.rmAll(code.C)" v-model="param.packing" placeholder="선택해주세요" outlined :filled="this.stat === 2 || this.data.stat === 2" :disabled="this.stat === 2 || this.data.stat === 2" id="work"></v-select>
            </li>
            <li>
              <h4>배송방법</h4>
              <v-select :items="this.rmAll(code.D)" v-model="param.delivery_type" placeholder="선택해주세요" outlined id="work" :filled="this.stat === 2 || this.data.stat === 2" :disabled="this.stat === 2 || this.data.stat === 2"></v-select>
            </li>
          </ul>
          <ul class="filter-list_address">
            <li class="dp--collums" style="margin-top: 30px">
              <h4>배송지 선택</h4>
              <div class="dp--row" style="width: 100%; align-items: flex-start; gap: 0">
                <v-text-field placeholder="" type="text" outlined dense filled disabled v-model="param.address" :rules="[this.validSet.empty(param.address, '주소를 입력해주세요')]" />
                <v-btn depressed class="ml-1 btn-address-search" :filled="this.stat === 2 || this.data.stat === 2" :disabled="this.stat === 2 || this.data.stat === 2" @click="searchAddress">주소검색</v-btn>
                <v-btn depressed class="ml-1 btn-address-search btn-sample-request" @click="searchAddressPT">배송지 검색</v-btn>
              </div>
            </li>
            <li style="margin-top: 10px">
              <h4 class="">상세주소*</h4>
              <v-text-field placeholder="" type="text" outlined dense :filled="this.stat === 2 || this.data.stat === 2" :disabled="this.stat === 2 || this.data.stat === 2" v-model="param.address2" :rules="[this.validSet.empty(param.address2, '상세 주소를 입력해주세요')]" />
            </li>
          </ul>
        </div>
        <div class="filter-box">
          <ul class="filter-list_address">
            <li>
              <h4>분석 특이사항</h4>
              <v-text-field outlined dense v-model="param.report_analysis" :filled="this.stat === 2 || this.data.stat === 2" :disabled="this.stat === 2 || this.data.stat === 2"></v-text-field>
            </li>
            <li style="margin-top: 30px">
              <h4>고객요청 특이사항</h4>
              <v-text-field outlined dense v-model="param.request_etc" :filled="this.stat === 2 || this.data.stat === 2" :disabled="this.stat === 2 || this.data.stat === 2"></v-text-field>
            </li>
            <li style="margin-top: 30px">
              <h4>제조상 특이사항</h4>
              <v-text-field outlined dense v-model="param.produce_etc" :filled="this.stat === 2 || this.data.stat === 2" :disabled="this.stat === 2 || this.data.stat === 2"></v-text-field>
            </li>
            <li style="margin-top: 30px">
              <h4>포장 및 배송관련 특이사항</h4>
              <v-text-field outlined dense v-model="param.delivery_etc" :filled="this.stat === 2 || this.data.stat === 2" :disabled="this.stat === 2 || this.data.stat === 2"></v-text-field>
            </li>
          </ul>
        </div>
      </div>
      <div class="filter-box filter-box--row mt-6">
        <div class="mail-section-content">
          <div class="mail-row">
            <div class="mail-field">
              <div class="dp--row align-center justify-content-between mb-2">
                <h4 class="mb-0">받는 사람</h4>
                <v-btn depressed small class="btn-sample-request" @click="openEmailList" :disabled="this.stat === 2 || this.data.stat === 2">이메일 추가</v-btn>
              </div>
              <div class="selected-emails-container" :class="{ readonly: this.stat === 2 || this.data.stat === 2, 'invalid-input': isIvd_email_list }">
                <div v-if="selectedEmailList.length === 0" class="no-emails">이메일을 추가해 주세요.</div>
                <div v-for="(emailObj, index) in selectedEmailList" :key="index" class="selected-email-item">
                  <span class="email-text">{{ emailObj.email }}</span>
                  <v-btn icon x-small @click="removeEmail(index)" class="ml-1" v-if="!(stat === 2 || data.stat === 2)">
                    <v-icon small color="red">mdi-close-circle</v-icon>
                  </v-btn>
                </div>
              </div>
              <div class="add-email-form">
                <div class="dp--row add-email-fields-row">
                  <div class="add-email-input-group">
                    <h4 class="mb-0">이름</h4>
                    <v-text-field ref="add_email_name" v-model="param.add_email_name" outlined dense placeholder="이름" hide-details class="filter-text-field" :filled="this.stat === 2 || this.data.stat === 2" :disabled="this.stat === 2 || this.data.stat === 2"></v-text-field>
                  </div>
                  <div class="add-email-input-group">
                    <h4 class="mb-0">이메일</h4>
                    <div class="dp--row align-center">
                      <v-text-field ref="add_email_address" v-model="param.add_email_address" outlined dense placeholder="이메일 주소" hide-details :rules="[validSet.email]" class="filter-text-field" :filled="this.stat === 2 || this.data.stat === 2" :disabled="this.stat === 2 || this.data.stat === 2"></v-text-field>
                      <v-btn depressed small class="btn-sample-request ml-2" @click="addEmail" :disabled="this.stat === 2 || this.data.stat === 2">추가</v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mail-field">
              <h4>메일 본문 추가 작성</h4>
              <v-textarea ref="mail_content" outlined rows="6" class="filter-textarea" dense placeholder="" v-model="param.mail_content" :disabled="this.stat === 2 || this.data.stat === 2" :filled="this.stat === 2 || this.data.stat === 2"></v-textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="wrapper wrapper-br">
        <div class="btn-box">
          <v-card-actions>
            <v-btn depressed class="btn-cancle" @click="cancle">취소</v-btn>
          </v-card-actions>
          <v-card-actions>
            <v-btn depressed class="btn-confim" :disabled="isDisabled" @click="save">완료 </v-btn>
          </v-card-actions>
        </div>
      </div>
    </v-form>
  </div>
</template>
<script>
import _ from 'lodash';
import { scrollToTop } from '@/utils/common_utils';
import { columns, fields, rows, height } from '@/assets/grid/sampleRequestLotNo';
import { mapState, mapMutations } from 'vuex';
import RealGrid from '@/components/RealGrid.vue';
import CodeSearch from '@/components/CodeSearch.vue';
import SetPopup from '@/components/SetPopup.vue';
import validSet from '@/assets/valid';
import { searchproduce } from 'api/sample/sample';
import { updateSampleStat, produceupdate, produceupdate2, codedbsearch, codedbcreate, selectSampleMailList, deleteSampleMailList, insertSampleMailList } from 'api/sample/sample';
import { partnerDocEmailList, insertPartnerDocEmail } from 'api/partnerDocEmail/partnerDocEmail';
import { getCode } from 'api/common';
import { withOriginLimit, ORIGIN_LIMIT_CODE_GROUP, ORIGIN_LIMIT_NONE } from '@/assets/displayCode';
import { emailRegex } from '@/assets/regex';
import SetDialog from '@/components/SetDialog.vue';
import AddressPTSearch from '@/components/AddressPTSearch.vue';
import moment from 'moment';

export default {
  props: ['data'],
  data() {
    const outDateExists = 'out_date' in this.data; // 출하 완료일이 입력된 경우 수정 불가
    const statCheck = this.data.stat;

    const doconly = this.data.doconly;
    const coawant = this.data.coawant;

    if (coawant == 1) {
      this.coawant = true;
    }

    if (doconly == 1) {
      this.doconly = true;
    }

    let editableColumns = _.cloneDeep(columns);
    if (statCheck == 2) {
      this.cancel = true;
      editableColumns.map(column => {
        column.editable = false;
        return column;
      });
    }

    if (statCheck != 2) {
      editableColumns.map(column => {
        // 조성 정보 lotNo 빼고 모든 컬럼 수정가능
        if (!outDateExists && column.fieldName !== 'lotNo') {
          column.editable = true;
        } else {
          column.editable = false;
        }
        return column;
      });
    }
    return {
      approveAddressPTKey: 0,
      isFetching: false,
      isDataLoaded: false,
      isSame: true,
      id: '',
      isDisabled: true,
      codeGrade: this.data.code ? this.data.code : '',
      codeGradeExist: true,
      originLimitCode: this.data.origin_limit_code ? this.data.origin_limit_code : '',
      originLimitOptions: [ORIGIN_LIMIT_NONE],
      // 저장된 제조완료일. 화면에서 날짜만 고른 상태로는 원산지 제한을 잠그지 않는다.
      savedProduceDate: this.data.produce_date || '',
      buttonDisabled: false,
      produceReport: [],
      message: [],
      cancel: false, // stat 처음 기본값
      cancelChanged: false,
      produceDateChk: false,
      stat: 0,
      val: 0,
      filled: this.data.stat == 2 ? true : false,
      coawant: this.data.coawant == 1 ? true : false,
      doconly: this.data.doconly == 1 ? true : false,
      codeList: [],
      picker_1: false,
      picker_2: false,
      picker_3: false,
      picker_4: false,
      picker_5: false,
      picker_6: false,
      validSet,
      grid: 'delivaryReportDetail',
      gridRow: {},
      gridUpdateChk: false,
      gridPairChk: true,
      isIvd_email_list: false,
      // matchingItems: {},
      settings: {
        columns,
        fields,
        rows,
        height,
        hideCheckBar: true,
        noneNo: true,
      },
      settingsEditable: {
        columns: editableColumns,
        fields,
        rows,
        height,
        hideCheckBar: true,
        noneNo: true,
      },
      param: {
        salestype: this.data.salestype, // 분류
        request_date: this.data.request_date, // 요청일
        request_name: this.data.request_name, // 요청자
        request_company: this.data.request_company, // 요청업체명
        request_company_code: this.data.request_company_code, // 요청업체명코드
        produce_due_date: this.data.produce_due_date, //  제조 예정일
        produce_date: this.data.produce_date, // 제조 완료일
        out_date: this.data.out_date, // 출하 완료일
        out_due_date: this.data.out_due_date, // 출하 예정일
        delivery_due_date: this.data.delivery_due_date, // 납기 예정
        pickpart: this.data.pickpart, // 수령업체명
        price_type: this.data.price_type2, // 유 무상
        qty: this.data.qty2, // qty
        delivery_date: this.data.delivery_date, // 납기 완료
        ww: this.data.ww,
        stat: this.data.stat,
        cancel: this.cancel,
        coawant,
        doconly,
        phone1: this.data.phone1,
        phone2: this.data.phone2,
        pick_name: this.data.pick_name,
        address: this.data.address,
        address2: this.data.address2,
        postcode: this.data.postcode,
        packing: this.data.packing, // 포장 용기
        delivery_type: this.data.delivery_type, // 배송 방법
        request_code: this.data.request_code, // 요청 자재코드
        report_analysis: this.data.report_analysis, // 분석 특이사항
        request_etc: this.data.request_etc, // 고객요청 특이사항
        produce_etc: this.data.produce_etc, // 제조상 특이 사항
        delivery_etc: this.data.delivery_etc, // 포장 및 배송 관련 특이사항
        mail_content: this.data.mail_content, // 메일 본문
        coa_mail_enabled_yn: 'N',
        msds_mail_enabled_yn: 'N',
        add_email_name: '',
        add_email_address: '',
      },
      searchRequest: {},
      selectedEmailList: [],
      removedEmailIdxList: [],
      emailGridSettings: {
        columns: [
          {
            name: 'name',
            fieldName: 'name',
            width: 150,
            header: { text: '이름' },
            editable: false,
          },
          {
            name: 'email',
            fieldName: 'email',
            width: 250,
            header: { text: '이메일' },
            editable: false,
          },
        ],
        fields: [
          { fieldName: 'name', dataType: 'text' },
          { fieldName: 'email', dataType: 'text' },
        ],
        rows: [],
        height: 400,
        radio: false,
        checkBar: true,
      },
    };
  },
  methods: {
    ...mapMutations('popup', ['SET_POPUP', 'SET_POPUP_TEXT']),
    ...mapMutations('menu', ['REMOVE_SELECT_MENU']),
    ...mapMutations('member', ['SET_USER_INFO']),
    ...mapMutations('modal', ['SET_DIALOG_TITLE', 'SET_DIALOG_TEXT', 'SET_HIGHT', 'SET_MAX_WIDTH', 'SET_MODAL', 'RESET_MODAL']),

    valid() {
      return this.$refs.form.validate();
    },
    setModal(msg, closable, cb) {
      this.SET_POPUP({
        title: '알림',
        // height: 150,
        width: 300,
        closable: closable,
        text: msg,
      });
      this.$refs.confirm.openPopup(cb);
    },
    setModalAutoClose(msg, closable, cb, autoclose) {
      this.SET_POPUP({
        title: '조성 데이터가 누락되었습니다.',
        // height: 150,
        width: 350,
        closable: closable,
        text: msg,
      });
      this.$refs.confirm.openPopupAutoClose(cb, autoclose, 1800);
      scrollToTop();
    },
    read() {
      this.columnKeyValueChecked();

      const row = this.$refs.grid.getJsonRow();
      const lotNo = this.data.lotNo;
      this.checkPairs(row);
      this.gridUpdateChk = false;
      this.buttonDisabled = false;
      this.isDisabled = false;

      if (!this.gridPairChk) {
        this.setModalAutoClose('성분명과 볼륨은 세트로 입력되야 합니다.<br>누락된 데이터를 입력해주세요.', false, null, true);
        return;
      }

      if (this.gridPairChk) {
        codedbsearch({
          lotNo,
          memberId: this.id,
          ...row,
        })
          .then(res => {
            const data = res.data.data;
            if (data) {
              this.codeGradeExist = true;
              if (data.list) {
                //여러개
                const list = data.list;
                this.codeList = list;
                this.searchCode();
              } else {
                //1개
                this.codeGrade = data.CODE;
              }
              this.message = []; // 초기화. ['']를 쓰지 않는다.
            } else {
              this.setModal('동일 목록이 없습니다', false, () => {});
              this.message = ['동일 목록이 없습니다. Code Grade를 신규 생성해 주세요.'];
              this.codeGradeExist = false;
            }
          })
          .catch(() => {});
      }
    },
    reset() {
      this.codeGradeExist = true;
      this.codeList = [];
      this.message = [];
      this.param = {
        salestype: this.data.salestype,
        request_date: this.data.request_date,
        request_name: this.data.request_name,
        request_company: this.data.request_company,
        request_company_code: this.data.request_company_code,
        produce_due_date: this.data.produce_due_date,
        produce_date: this.data.produce_date,
        out_date: this.data.out_date,
        out_due_date: this.data.out_due_date,
        delivery_due_date: this.data.delivery_due_date,
        pickpart: this.data.pickpart,
        price_type: this.data.price_type2,
        qty: this.data.qty,
        delivery_date: this.data.delivery_date,
        phone1: this.data.phone1,
        phone2: this.data.phone2,
        pick_name: this.data.pick_name,
        address: this.data.address,
        address2: this.data.address2,
        postcode: this.data.postcode,
        packing: this.data.packing,
        delivery_type: this.data.delivery_type,
        request_code: this.data.request_code,
        report_analysis: this.data.report_analysis,
        request_etc: this.data.request_etc,
        produce_etc: this.data.produce_etc,
        delivery_etc: this.data.delivery_etc,
      };
    },
    searchCode() {
      this.$refs.code.open();
    },
    cancle() {
      this.setModal('취소하시겠습니까', true, () => {
        this.reset();
        this.REMOVE_SELECT_MENU('delivaryReportDetail');
      });
    },
    calendarRemove(field) {
      // 잘못 선택한경우 삭제 방법이 없어서 기능을 추가함(조제예정일)
      this.setModal('등록된 날짜를 삭제하시겠습니까?<br>변경된 날짜는 하단 "완료" 버튼 클릭 후 적용을 해 주셔야 합니다.', true, () => {
        this.param[field] = undefined;
      });
    },
    columnKeyValueChecked() {
      this.$refs.grid.checkKeyValuePairs(0, 2);
    },
    save() {
      const row = this.$refs.grid.getJsonRow();
      this.columnKeyValueChecked();
      this.checkPairs(row);
      if (!this.gridPairChk) {
        this.setModalAutoClose('성분명과 볼륨은 세트로 입력되야 합니다.<br>누락된 데이터를 입력해주세요.', false, null, true);
        return;
      }

      // 메일 발송 대상인데 수신자가 없는 경우 체크
      if ((this.param.coa_mail_enabled_yn === 'Y' || this.param.msds_mail_enabled_yn === 'Y') && this.selectedEmailList.length === 0) {
        this.isIvd_email_list = true;
        this.setModal('받는 사람 정보를 입력해주세요.', false, () => {});
        return;
      } else {
        this.isIvd_email_list = false;
      }

      // 기존 코드 그레이드 있는 경우.
      if (this.oldCodeGrade != '' && this.oldCodeGrade != undefined) {
        // 조성항목 변경이 되고 신규 코드가 없는 경우.
        if (!this.isSame && (this.codeGrade == '' || this.codeGrade == undefined)) {
          this.setModal('조성항목 변경 : <br>Code Grade 재검색 또는 신규 생성을 하셔야 합니다.');
          scrollToTop();
          return;
        }
      }
      if (this.valid() && this.gridPairChk) {
        // && this.cancelChanged
        // 그리드 업데이트하지 않았을 시,
        if (this.gridUpdateChk) {
          // 그리드 업데이트 시,
          if (this.oldCodeGrade != '' && this.oldCodeGrade != undefined && !this.codeGrade) {
            this.message = ['Code Grade 재검색 또는 신규 생성을 하셔야 합니다.'];
            scrollToTop();
          }
        }
        // if (this.gridUpdateChk) { 문에 있던 내용을 이동하였음.
        this.setModal('저장 하시겠습니까', true, () => {
          this.saveExec();
        });
      }
    },
    newCode() {
      this.gridUpdateChk = false;
      this.produceDateChk = false;
      const row = this.$refs.grid.getJsonRow();
      this.checkPairs(row);
      if (this.gridPairChk) {
        codedbcreate({
          lotNo: this.data.lotNo,
          memberId: this.id,
          ...row,
        })
          .then(res => {
            if (res.data.errorMessage) {
              this.setModal(res.data.errorMessage);
            } else {
              this.codeGrade = res.data.data.code;
              this.message = []; // 초기화  [''];
            }
          })
          .catch(err => {
            this.setModal(err.errorMessage);
          });
      }
    },
    async saveExec() {
      const row = this.$refs.grid.getJsonRow();

      if (this.val == 2) {
        updateSampleStat({
          stat: this.val,
          lotNo: this.data.lotNo,
          memberId: this.id,
        })
          .then(() => {})
          .catch(() => {});
      } else if (this.val == 1) {
        updateSampleStat({
          stat: this.val,
          lotNo: this.data.lotNo,
          memberId: this.id,
        })
          .then(() => {})
          .catch(() => {});
      }

      // 삭제된 이메일 처리
      if (this.removedEmailIdxList.length > 0) {
        deleteSampleMailList({
          idxList: this.removedEmailIdxList,
        }).catch(err => console.error('Error deleting emails:', err));
      }

      // 새로 추가된 이메일 처리
      const newEmails = this.selectedEmailList.filter(e => e.isNew).map(e => e.email);
      if (newEmails.length > 0) {
        const mailParams = {
          lot_no: this.data.lotNo,
          emailList: newEmails,
          reg_dt: moment().format('YYYY-MM-DD HH:mm:ss'),
          upd_dt: moment().format('YYYY-MM-DD HH:mm:ss'),
          memberId: this.id,
        };
        insertSampleMailList(mailParams).catch(err => console.error('Error inserting emails:', err));
      }

      console.log(this.param, 'this.param');
      if (this.codeGrade === '') {
        produceupdate2({
          ...this.param,
          ...row,
          code: '',
          origin_limit_code: this.originLimitCode,
          lotNo: this.data.lotNo,
          memberId: this.id,
        })
          .then(() => {
            this.REMOVE_SELECT_MENU('delivaryReportDetail');
          })
          .catch(err => {
            this.setModal(err);
          });
      } else {
        produceupdate({
          ...this.param,
          ...row,
          code: this.codeGrade,
          origin_limit_code: this.originLimitCode,
          lotNo: this.data.lotNo,
          memberId: this.id,
        })
          .then(() => {
            this.REMOVE_SELECT_MENU('delivaryReportDetail');
          })
          .catch(err => {
            this.setModal(err);
          });
      }
    },
    populateGridRow() {
      // 납품일보목록 에서 가져온 조성정보를 따로 저장
      const keys = Object.keys(this.data);
      keys.forEach(key => {
        const solvent = key.startsWith('solvent') && parseInt(key.replace('solvent', '')) <= 10;
        const solventVol = key.startsWith('solventVol') && parseInt(key.replace('solventVol', '')) <= 10;
        const salt = key.startsWith('salt') && parseInt(key.replace('salt', '')) <= 5;
        const saltVol = key.startsWith('saltVol') && parseInt(key.replace('saltVol', '')) <= 5;
        const add = key.startsWith('add') && parseInt(key.replace('add', '')) <= 15;
        const addVol = key.startsWith('addVol') && parseInt(key.replace('addVol', '')) <= 15;

        if (solvent || solventVol || salt || saltVol || add || addVol || key === 'ww') {
          this.gridRow[key] = this.data[key];
        }
      });
    },
    // 공통코드에서 원산지 제한 목록을 받는다. 설명이 있으면 설명을 보여주고 값은 접미사 그대로 저장한다.
    // 항목이 늘어도 여기는 손대지 않는다.
    async loadOriginLimitOptions() {
      try {
        const res = await getCode(ORIGIN_LIMIT_CODE_GROUP);
        const rows = res.data.data || [];
        const options = rows.filter(v => v.val).map(v => ({ value: v.val, label: v.description ? v.description : v.val }));
        this.originLimitOptions = [ORIGIN_LIMIT_NONE, ...options];
      } catch (err) {
        this.originLimitOptions = [ORIGIN_LIMIT_NONE];
      }
    },
    onKeyPress(val) {
      this.produceDateChk = val;
    },
    compareRowAndGrid() {
      this.isSame = true; // 조성 변화 없다고 가정 하에 시작한다.

      this.codeGrade = '';
      this.buttonDisabled = true;

      let row = this.$refs.grid.getJsonRow();
      let rowReSet = {};
      for (let r in row) {
        if (r == 'lotNo') continue;
        if (row[r] != undefined && row[r] != '') {
          if (r == 'ww' || r.startsWith('solventVol') || r.startsWith('saltVol') || r.startsWith('addVol')) {
            rowReSet[r] = parseFloat(row[r]); // parseInt(row[r]);
          } else {
            rowReSet[r] = row[r];
          }
        }
      }

      // const keys = new Set([...Object.keys(row), ...Object.keys(this.gridRow)]); // 두개 합치는거임
      const keysToCompare = Object.keys(this.gridRow); // 원본 조성 데이터.
      let rowReSetCount = Object.keys(rowReSet).length;
      let gridRowCount = Object.keys(this.gridRow).length;

      if (rowReSetCount !== gridRowCount) {
        this.isSame = false;
      } else {
        for (let key of keysToCompare) {
          if (this.gridRow[key] != rowReSet[key]) {
            this.isSame = false;
            break;
          }
        }
      }

      if (this.isSame) {
        // isSame true면 조성정보가 모두 같음 / 변경된게 없다.
        this.gridUpdateChk = false;
        this.codeGrade = this.oldCodeGrade;
        this.isDisabled = true;
        this.message = []; // 조성 변경이 없는 경우 메세지 삭제.
      } else {
        this.gridUpdateChk = true;
        this.codeGrade = '';
        this.isDisabled = false; // 조성 물질 변경 시 저장 버튼 활성화.
        // 기존 코드 값이 있는 경우.
        if (this.oldCodeGrade != '' && this.oldCodeGrade != undefined) {
          this.message = ['조성 항목 변경. Code Grade 재검색 또는 신규 생성해야 합니다.'];
        }
      }
    },
    trueValue(val) {
      // 체크박스 체크 되었을때
      this.val = val;
      this.stat = 2;
      // eslint-disable-next-line vue/no-mutating-props
      this.data.stat = this.stat;
      this.$refs.grid.setColumnsEditable(); // 입력 못하게 막음
      this.$refs.grid.setRowStyleCallback();
    },
    falseValue(val) {
      this.val = val;
      this.stat = 1;
      // eslint-disable-next-line vue/no-mutating-props
      this.data.stat = this.stat;
      const outDateExists = 'out_date' in this.data;
      if (!outDateExists) {
        this.$refs.grid.setColumnsEditable2(); // 입력 풀기
        this.$refs.grid.setRowStyleCallback2();
      }
    },
    searchAddress() {
      new window.daum.Postcode({
        oncomplete: data => {
          this.param.address = data.address;
          this.param.address2 = data.address2;
          this.param.postcode = data.zonecode;
        },
      }).open();
    },
    isBlank(str) {
      return !str || /^\s*$/.test(str);
      // null, undefined, "" 경우 true 반환
    },
    checkPairs(row) {
      const result = [];
      for (let i = 1; i <= 10; i++) {
        const solvent = 'solvent' + i;
        const solventVol = 'solventVol' + i;

        if ((row[solvent] && !this.isBlank(row[solvent])) || (row[solventVol] && !this.isBlank(row[solventVol]))) {
          if (!(row[solvent] && !this.isBlank(row[solvent]) && row[solventVol] && !this.isBlank(row[solventVol]))) {
            this.gridPairChk = false;
            return [];
          }
          if (row[solvent] && !this.isBlank(row[solvent]) && !row[solventVol] && !this.isBlank(row[solventVol])) {
            this.gridPairChk = false;
            return [];
          }
          result.push({
            [solvent]: row[solvent],
            [solventVol]: row[solventVol],
          });
        }
      }
      // salt와 saltVol 페어 확인
      for (let i = 1; i <= 5; i++) {
        const salt = 'salt' + i;
        const saltVol = 'saltVol' + i;

        if ((row[salt] && !this.isBlank(row[salt])) || (row[saltVol] && !this.isBlank(row[saltVol]))) {
          if (!(row[salt] && !this.isBlank(row[salt]) && row[saltVol] && !this.isBlank(row[saltVol]))) {
            this.gridPairChk = false;
            return [];
          }
          if (row[salt] && !this.isBlank(row[salt]) && !row[saltVol] && !this.isBlank(row[saltVol])) {
            this.gridPairChk = false;
            return [];
          }
          result.push({
            [salt]: row[salt],
            [saltVol]: row[saltVol],
          });
        }
      }
      // add와 addVol 페어 확인
      for (let i = 1; i <= 15; i++) {
        const add = 'add' + i;
        const addVol = 'addVol' + i;

        if ((row[add] && !this.isBlank(row[add])) || (row[addVol] && !this.isBlank(row[addVol]))) {
          if (!(row[add] && !this.isBlank(row[add]) && row[addVol] && !this.isBlank(row[addVol]))) {
            this.gridPairChk = false;
            return [];
          }
          if (row[add] && !this.isBlank(row[add]) && !row[addVol] && !this.isBlank(row[addVol])) {
            this.gridPairChk = false;
            return [];
          }
          result.push({
            [add]: row[add],
            [addVol]: row[addVol],
          });
        }
      }
      this.gridPairChk = true;
      return result;
    },
    async loadData() {
      if (this.isFetching) return;
      this.isFetching = true;

      try {
        const response = await searchproduce({
          viewName: 'delivery',
          lotNo: this.data.lotNo,
        });

        this.isDataLoaded = true;
        this.isSame = true;
        this.codeGradeExist = true;
        this.buttonDisabled = false;
        this.message = [];
        this.cancel = false;
        this.coawant = false;
        this.doconly = false;
        this.cancelChanged = false;
        this.produceDateChk = false;
        this.stat = 0;
        this.val = 0;

        this.filled = this.data.stat == 2 ? true : false;
        // this.codeList = [];
        this.picker_1 = false;
        this.picker_2 = false;
        this.picker_3 = false;
        this.picker_4 = false;
        this.picker_5 = false;
        this.picker_6 = false;
        this.gridUpdateChk = false;
        this.gridPairChk = false;
        this.gridRow = {}; // 서버 통신 후 새로운 데이터로 교체 전 초기화.

        // const response = res.data;

        const items = response.data.data.items;

        console.log(items, 'items');

        const item = items[0];
        this.$refs.grid.loadData(items);
        this.codeGrade = item.code; // 코드
        this.oldCodeGrade = item.code; // 코드 원본
        this.param.salestype = item.salestype; // 분류
        this.param.request_company = item.request_company; // 요청업체명
        this.param.request_company_code = item.request_company_code; // 요청업체명
        this.param.request_name = item.request_name; // 요청자
        this.param.phone1 = item.phone1; // 요청자 연락처
        this.param.phone2 = item.phone2; // 수령자 연락처
        this.param.pickpart = item.pickpart; // 수령업체명
        this.param.pick_name = item.pick_name; // 수령자
        this.param.address = item.address; // 주소
        this.param.address2 = item.address2; // 상세주소
        this.param.request_date = item.request_date; // 요청일
        //(this.param.cancel = item.cancel), // 샘플취소
        this.param.produce_due_date = item.produce_due_date; //  제조 예정일
        this.param.produce_date = item.produce_date; // 제조 완료일
        this.savedProduceDate = item.produce_date || '';
        this.param.out_due_date = item.out_due_date; // 출하 예정일
        this.param.out_date = item.out_date; // 출하 완료일
        this.param.delivery_due_date = item.delivery_due_date; // 납기 예정일
        this.param.delivery_date = item.delivery_date; // 납기일
        this.param.qty = item.qty2; // qty
        this.param.price_type = item.price_type2; // 유 무상
        this.param.packing = item.packing; // 포장용기
        this.param.delivery_type = item.delivery_type; // 배송 방법
        this.param.request_code = item.request_code; // 요청 자재코드
        this.param.report_analysis = item.report_analysis; // 분석 특이사항
        this.param.request_etc = item.request_etc; // 고객요청 특이사항
        // searchproduce에서 병합되어 내려온다.
        this.param.produce_etc = item.produce_etc; // 제조상 특이 사항
        this.param.delivery_etc = item.delivery_etc; // 포장 및 배송 관련 특이사항
        // 병합되어 내려오니 아래 코드는 필요 없을듯.
        // if (this.matchingItems) {
        //   this.param.produce_etc = this.matchingItems.produce_etc; // 제조상 특이 사항
        //   this.param.delivery_etc = this.matchingItems.delivery_etc; // 포장 및 배송 관련 특이사항
        // }
        this.param.ww = item.ww; // ww
        // this.param.stat= item.stat, // 샘플 상태
        this.param.postcode = item.postcode; // 우편번호
        this.param.mail_content = item.mail_content; // 메일 본문
        this.param.coa_mail_enabled_yn = item.coa_mail_enabled_yn || 'N';
        this.param.msds_mail_enabled_yn = item.msds_mail_enabled_yn || 'N';

        // 이메일 목록 조회
        this.selectedEmailList = [];
        this.removedEmailIdxList = [];
        selectSampleMailList(this.data.lotNo)
          .then(res => {
            this.selectedEmailList = res.data.data;
          })
          .catch(err => {
            console.error('Error fetching email list:', err);
          });

        this.populateGridRow();
        this.$refs.grid.allRemoveUserCellStyle(); // 라인 색상 클래스 삭제.
        scrollToTop();
        // 제조완료일 없는 경우.
        if (item.produce_date == '' || item.produce_date == undefined || item.produce_date == null) {
          this.$refs.grid.setColumnsEditable2();
          this.$refs.grid.setRowStyleCallbackDefault();
        } else {
          this.$refs.grid.setColumnsEditable();
          this.$refs.grid.setRowStyleCallback();
        }
      } catch (err) {
        this.error = err.message;
      } finally {
        this.isFetching = false;
      }
    },
    closeModalAddressPT() {},
    searchAddressPT() {
      const searchRequest = {
        ptCd: this.param.request_company_code,
        pickname: '',
        open_yn: 'Y',
        search_yn: 'Y',
        currentPage: 1,
        pageSize: process.env.VUE_APP_DEFAULT_PAGE_LX_SIZE || 100000,
      };

      this.SET_MODAL({
        // height: 600,
        width: 800,
        closable: true,
        customApprove: true,
      });

      this.searchRequest = searchRequest;
      this.$refs.postModalAddressPT.openModal();
    },
    closeAddressPT() {
      this.$refs.postModalAddressPT.closeModal();
      this.approveAddressPTKey = moment().valueOf();
    },
    approveAddressPT(address) {
      if (address) {
        this.param.pick_name = address.pickname;
        this.param.phone2 = address.phone2;
        this.param.postcode = address.postcode;
        this.param.address = address.address1;
        this.param.address2 = address.address2;
      }
    },
    openEmailList() {
      if (this.param.request_company_code === '') {
        this.setModal('요청업체가 선택되지 않았습니다.', false, () => {});
        return false;
      }

      partnerDocEmailList(this.param.request_company_code)
        .then(res => {
          const list = res.data.data;
          this.SET_MODAL({
            width: 500,
            closable: true,
            customApprove: true,
          });
          this.SET_DIALOG_TITLE('이메일 추가');
          this.$refs.emailListModal.openModal();
          this.$nextTick(() => {
            this.$refs.emailGrid.loadData(list);
          });
        })
        .catch(err => {
          console.error('Error fetching email list:', err);
          this.setModal('주소록을 불러오는 중 오류가 발생했습니다.', false, () => {});
        });
    },
    applyEmails() {
      const checkedRows = this.$refs.emailGrid.getCheckedRow();
      if (checkedRows.length === 0) {
        this.setModal('추가할 이메일을 선택해 주세요.', false, () => {});
        return false;
      }

      const newEmails = checkedRows.map(row => ({
        email: row.data.email,
        isNew: true,
      }));

      // 중복 제거 후 추가
      const currentEmails = this.selectedEmailList.map(e => e.email);
      const filteredNewEmails = newEmails.filter(ne => !currentEmails.includes(ne.email));

      if (filteredNewEmails.length > 0) {
        this.selectedEmailList = [...this.selectedEmailList, ...filteredNewEmails];
        this.isDisabled = false; // 이메일 추가 시 버튼 활성화
      }
      this.closeEmailModal();
    },
    removeEmail(index) {
      const emailObj = this.selectedEmailList[index];
      if (emailObj.idx) {
        this.removedEmailIdxList.push(emailObj.idx);
      }
      this.selectedEmailList.splice(index, 1);
      this.isDisabled = false; // 이메일 삭제 시 버튼 활성화
    },
    closeEmailModal() {
      this.$refs.emailListModal.closeModal();
    },
    addEmail() {
      const name = this.param.add_email_name.trim();
      const email = this.param.add_email_address.trim();

      if (!name || !email) {
        this.setModal('이름과 이메일 주소를 모두 입력해주세요.', false, () => {});
        return;
      }

      if (!emailRegex.test(email)) {
        this.setModal('유효한 이메일 주소를 입력해주세요.', false, () => {});
        return;
      }

      if (this.param.request_company_code === '') {
        this.setModal('요청업체가 선택되지 않았습니다.', false, () => {});
        return;
      }

      const currentEmails = this.selectedEmailList.map(e => e.email);
      if (currentEmails.includes(email)) {
        this.setModal('이미 추가된 이메일입니다.', false, () => {});
        return;
      }

      this.selectedEmailList.push({ email, isNew: true });
      this.param.add_email_name = '';
      this.param.add_email_address = '';
      this.isDisabled = false;

      this.callInsertPartnerDocEmail(name, email);
    },
    async callInsertPartnerDocEmail(name, email) {
      try {
        const data = {
          pt_cd: this.param.request_company_code,
          name: name,
          email: email,
        };
        await insertPartnerDocEmail(data);
      } catch (error) {
        console.error('이메일 저장 중 오류 발생:', error);
        this.setModal('이메일 저장 중 오류가 발생했습니다.', false, () => {});
      }
    },
  },
  watch: {
    'param.cancel'(val) {
      this.cancelChanged = true;
      if (val) {
        // 체크 박스 체크 되었을떄
        const val = 2;
        this.filled = true;
        this.param.stat = 2;
        this.trueValue(val);
      } else {
        // 체크 박스 미 체크
        const val = 1;
        this.filled = false;
        this.param.stat = 1;
        this.falseValue(val);
      }
    },
    // eslint-disable-next-line no-unused-vars
    'param.produce_date'(val) {
      //제조완료일 없는 경우
      if (val == undefined || val == '' || val == null) {
        this.$refs.grid.setColumnsEditable2();
        this.$refs.grid.setRowStyleCallbackDefault();
      } else {
        this.$refs.grid.setColumnsEditable(); // 입력 못하게 막음
        this.$refs.grid.setRowStyleCallback();
      }
    },
    'param.coawant'(val) {
      this.cancelChanged = true;
      if (val) {
        // 체크 박스 체크 되었을떄
        this.coawant = true;
        this.param.coawant = 1;
      } else {
        // 체크 박스 미 체크
        this.coawant = false;
        this.param.coawant = 0;
      }
    },
    'param.doconly'(val) {
      this.cancelChanged = true;
      if (val) {
        // 체크 박스 체크 되었을떄
        this.doconly = true;
        this.param.doconly = 1;
      } else {
        // 체크 박스 미 체크
        this.doconly = false;
        this.param.doconly = 0;
      }
    },
    param: {
      deep: true, // 지정한 속성안에 있는 속성의 값, 안에 삽인된 속성의 값도 감시
      // eslint-disable-next-line no-unused-vars
      handler: function (newVal, oldVal) {
        // param이 변경될때마다 실행
        for (const key in newVal) {
          if (newVal[key] !== this.data[key]) {
            // 데이터 비교
            this.isDisabled = false;
            return;
          }
        }
        // 원산지 제한은 param 밖에 있어서 따로 비교한다.
        this.isDisabled = !this.originLimitChanged;
      },
    },
    originLimitCode() {
      if (this.originLimitChanged) {
        this.isDisabled = false;
        return;
      }
      // 원래 값으로 되돌렸으면 param 변경 여부로 다시 판단한다.
      this.isDisabled = !Object.keys(this.param).some(key => this.param[key] !== this.data[key]);
    },
  },
  computed: {
    // 취소됐거나 제조완료일이 저장된 뒤에는 원산지 제한을 바꿀 수 없다.
    originLimitLocked() {
      return this.stat === 2 || this.data.stat === 2 || !!this.savedProduceDate;
    },
    originLimitChanged() {
      return (this.originLimitCode || '') !== (this.data.origin_limit_code || '');
    },
    ...mapState('common', ['code']),
    // 저장은 원본 코드로 하고 화면에만 접미사를 붙인다.
    displayCodeGrade() {
      return withOriginLimit(this.codeGrade, this.originLimitCode);
    },
  },
  mounted() {
    this.id = this.$store.state.member.userInfo.memberId;
    this.gridRow = {}; // 다시 초기화
    this.loadOriginLimitOptions();

    // 이 부분은 새로운 데이터 fetch 후 하는 것으로 이동한다.
    // this.populateGridRow();
    this.loadData();
    const produceDateExists = 'produce_date' in this.data; // 제조완료일
    if (produceDateExists) {
      this.$refs.grid.setColumnsEditable();
      this.$refs.grid.setRowStyleCallback();
    }
  },
  components: {
    RealGrid,
    CodeSearch,
    SetPopup,
    SetDialog,
    AddressPTSearch,
  },
};
</script>
<style lang="scss">
.deliveryReportDetail {
  .v-input__slot {
    width: 100%;
  }
  /* 원산지 제한 선택. Code Grade 줄에 같이 놓이므로 폭을 잡아 준다. */
  .origin-limit-select {
    max-width: 160px;
    flex: 0 0 160px;
    /* 전역 .v-select__selections가 top:-2px 절대배치라, 잠겨서 filled가 되면 padding이 빠지며 글자가 위로 뜬다. 상태와 상관없이 세로 가운데로 맞춘다. */
    .v-select__selections {
      top: 0 !important;
      bottom: 0;
      padding: 0 !important;
      flex-wrap: nowrap;
    }
    .v-select__selection--comma {
      margin: 0 4px 0 0;
    }
  }
  .dongwha-btn-sm.v-btn.v-size--default {
    height: 24px !important;
    padding: 3px !important;
  }
  .dongwha-btn-sm .v-btn__content {
    font-size: 0.8em;
  }
  .error-alerts {
    padding: 5px;
    margin-bottom: 0px;
    margin-left: 10px;
  }
}
.v-alert {
  font-size: inherit !important;
}
.wrapper-br {
  padding-bottom: 30px;
}
.search-button {
  background-color: #f5f5f5;
  border-radius: 50%;
  padding: 8px;
  margin-left: 8px;
}
.default_cursor input {
  cursor: default;
}

.mail-section-wrapper {
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 20px;
}

.mail-section-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}

.mail-row {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.mail-field {
  flex: 1;
  min-width: 300px;
}

.mail-field h4 {
  margin-bottom: 10px;
  font-weight: bold;
}

.add-email-form {
  margin-top: 10px;
  border-top: 1px solid #eee;
  padding-top: 10px;
}

.add-email-fields-row {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.add-email-input-group {
  flex: 0 0 calc(50% - 10px);
  min-width: 150px;
}

.add-email-input-group:last-child {
  flex: 1;
}

.add-email-input-group h4 {
  margin-bottom: 5px !important;
  font-weight: bold;
  font-size: 14px;
  color: #262626;
}

.selected-emails-container {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 10px;
  min-height: 40px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  background-color: #f9f9f9;

  &.readonly {
    background-color: #f5f5f5;
  }

  .no-emails {
    color: #999;
    font-size: 0.9rem;
  }

  .selected-email-item {
    background-color: #e8f5e9;
    border: 1px solid #c8e6c9;
    border-radius: 16px;
    padding: 2px 10px;
    display: flex;
    align-items: center;
    font-size: 0.85rem;
    color: #2e7d32;

    .email-text {
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.email-list-popup {
  padding: 20px;
  .popup-content {
    margin-bottom: 20px;
    border: 1px solid #ddd;
  }
  .popup-footer {
    display: flex;
    justify-content: center;
    gap: 10px;
  }
}
</style>
